<i18n src="../../locales/lang.json"></i18n>
<template>
  <div>
    <span class="discuss-notification" v-bind:class="'discuss-notification-' + type">
      <slot>

      </slot>
    </span>
  </div>
</template>

<script>
  export default {
    name: 'discussion-notification-icon',
    components: {
    },
    props: {
      type: {
        required: false,
        type: String,
        default: "default"
      },
    },
    methods: {
    
    },
    created() {
      
    },
    mounted() {
      
    }
}
</script>

<style scoped>
  .discuss-notification {
    float:left;
    position: relative;
    border-radius: .4em;
    display: inline-table;
    min-width: 10px;
    padding-left: 6px;
    padding-bottom: 0px;
    padding-top: 0px;
    padding-right: 6px;
    line-height: 10px;
    font-size: 10px;
    color: white;
  }

  .discuss-notification:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-bottom: 0;
    border-left: 0;
    margin-left: -2.5px;
    margin-bottom: -5px;
  }

  .discuss-notification-default {
    background: darkgray;
  }
  .discuss-notification-default:after {
    border-top-color: darkgray;
  }

  .discuss-notification-warning {
    background: #f58646;
  }

  .discuss-notification-warning:after {
    border-top-color: #f58646;
  }
</style>



// WEBPACK FOOTER //
// src/components/discuss/discussion-notification-icon.vue